/* eslint-disable prettier/prettier */
import { snakeToCamelTemplateLiterals, } from '@/common/converter/utils/snake-to-camel'
import { replacePlaceholder } from '@/common/converter/utils/replace-placeholder'
import { convertTitleList } from '@/common/converter/convert-title-list'
import { convertCellEvent } from '@/common/converter/convert-cell-event'
import { snakeToCamelObj } from '@/common/converter/utils/snake-to-camel-obj'

/**
 * source object (home) 와 target object (catalog) 를 받아
 * 구 instant player cell 형태를 반환 (band_82)
 * @param source
 * @param target
 * @returns {{actors: string, age: string, age_tag: string, bottom_taglist: string[], brand_taglist: string[], commingSoonReleaseDate: string, contentid: string, description: string, event_list: {bodylist: *, url: string}[], force_refresh: string, iszzim: string, rank: string, synopsis: string, thumbnail: string, time: string, title_list: unknown[], top_taglist: string[]}}
 */
export const convertCellInstantPlayer = (source = {}, target = {}) => {
  const { contextProperty = {}, eventList = [] } = source

  const thumbnail = snakeToCamelTemplateLiterals(contextProperty?.image?.thumbnail) ?? ''
  const titleList = contextProperty?.titleList.map(snakeToCamelTemplateLiterals) ?? []
  const brandTagList = contextProperty?.tag?.brandList ?? []
  const buttonText = snakeToCamelTemplateLiterals(contextProperty?.buttonText ?? '')
  const topTagList = contextProperty?.tag?.topList ?? []
  const bottomTagList = contextProperty?.tag?.bottomList ?? []
  const rank = snakeToCamelTemplateLiterals(contextProperty?.rank?.order) ?? ''
  const ratings = snakeToCamelTemplateLiterals(contextProperty?.ratings) ?? ''
  const isZzim = snakeToCamelTemplateLiterals(contextProperty?.likeStatus) ?? ''
  const metaTitleList = snakeToCamelObj(contextProperty?.metaTitleList)
  const contentId = snakeToCamelTemplateLiterals(contextProperty?.contentId) ?? ''
  const [ releaseDate = '', description = '', synopsis = '', actors = '' ] = metaTitleList
  const bgColor = snakeToCamelTemplateLiterals(contextProperty?.bgColor)
  const logoImage = snakeToCamelTemplateLiterals(contextProperty?.logoImage)
  const logoTitle = snakeToCamelTemplateLiterals(contextProperty?.logoTitle)
  const progress = snakeToCamelTemplateLiterals(contextProperty?.progress)
  return {
    actors: replacePlaceholder(actors, target),
    age: target?.personal?.targetage ?? '',
    age_tag: '',
    bgColor: replacePlaceholder(bgColor, target),
    bottom_taglist: bottomTagList.map((tag) => replacePlaceholder(tag, target)),
    brand_taglist: brandTagList.map((tag) => replacePlaceholder(tag, target)),
    buttonText: replacePlaceholder(buttonText, target),
    commingSoonReleaseDate: replacePlaceholder(releaseDate, target),
    contentid: replacePlaceholder(contentId, target),
    description: replacePlaceholder(description, target),
    event_list: eventList.map((event) => convertCellEvent(event, target)),
    force_refresh: 'n',
    iszzim: replacePlaceholder(isZzim, target),
    logoImage: replacePlaceholder(logoImage, target),
    logoTitle: replacePlaceholder(logoTitle, target),
    progress: replacePlaceholder(progress, target),
    rank: replacePlaceholder(rank, target) ?? '',
    ratings: replacePlaceholder(ratings, target) ?? '',
    synopsis: replacePlaceholder(synopsis, target),
    thumbnail: replacePlaceholder(thumbnail, target),
    time: '',
    title_list: titleList.map((title) => convertTitleList(replacePlaceholder(title, target)) ?? [],),
    top_taglist: topTagList.map((tag) => replacePlaceholder(tag, target)) ?? [],
  }
}
